<template>
    <div style="background-color: whitesmoke; padding: 20px; border-radius: 15px;">
        <b-modal id="modal-1" hide-footer hide-header centered no-close-on-backdrop>
            <b-progress value="100" max="100" animated variant="secondary"></b-progress>
        </b-modal>
        <CCardBody class="statistic_table_modify team_stats_table">
            <div style="width: 100px; float: left; margin-bottom: 0.5rem!important; margin-top: 0.5rem!important;margin-right: 20px!important;">
                <CSelect :options="week_filter" @update:value="set_items">
                </CSelect>
            </div>
            <CDataTable :items="items" :fields="fields" sorter tableFilter hover border outlined style="font-size: 12px;white-space: nowrap; font-weight: bold;" :loading='loading'>
                <template v-slot:thead-top="props">
                    <tr class="table_first_tr">
                        <th colspan="4" class="group-header">{{ $t('Fixture') }}</th>
                        <th colspan="7" class="group-header">{{ $t('Stats Last 10 Chance') }}</th>
                        <th colspan="3" class="group-header">{{ $t('Fav Label Best Bet') }}</th>
                        <th colspan="4" class="group-header">{{ $t('Match Odds') }}</th>
                        <th colspan="3" class="group-header">{{ $t('O / U 0.5 HT') }}</th>
                        <th colspan="3" class="group-header">{{ $t('O / U 2.5 FT') }}</th>
                        <th colspan="3" class="group-header">{{ $t('BTS') }}</th>
                    </tr>
                </template>
                <template #Stats="{item, index}">
                    <td class="group-stats-first">
                        <a :href="'/#/investments/details/' + item._id" target="_blank">"Stats"</a>
                    </td>
                </template>
                <template #match_odds_val="{item, index}">
                    <td class="group-match-odds-first">
                        <a v-if="item.match_marketId" :href="'https://www.betfair.com/exchange/plus/football/market/' + item.match_marketId" target="_blank">{{item.match_odds_val}}</a>
                        <a v-else>{{item.match_odds_val}}</a>
                    </td>
                </template>
                <template #ou05_ht_odds_val="{item, index}">
                    <td class="group-ou05-ht-first">
                        <a v-if="item.ou05_ht_marketId" :href="'https://www.betfair.com/exchange/plus/football/market/' + item.ou05_ht_marketId" target="_blank">{{item.ou05_ht_odds_val}}</a>
                        <a v-else>{{item.ou05_ht_odds_val}}</a>
                    </td>
                </template>
                <template #ou25_odds_val="{item, index}">
                    <td class="group-ou25-ft-first">
                        <a v-if="item.ou25_marketId" :href="'https://www.betfair.com/exchange/plus/football/market/' + item.ou25_marketId" target="_blank">{{item.ou25_odds_val}}</a>
                        <a v-else>{{item.ou25_odds_val}}</a>
                    </td>
                </template>
                <template #bts_odds_val="{item, index}">
                    <td class="group-bts-first">
                        <a v-if="item.bts_marketId" :href="'https://www.betfair.com/exchange/plus/football/market/' + item.bts_marketId" target="_blank">{{item.bts_odds_val}}</a>
                        <a v-else>{{item.bts_odds_val}}</a>
                    </td>
                </template>
                <template #competition="{item, index}">
                    <td>
                        <span style="display: block; text-align: left">{{ item.country }}</span>
                        <span style="display: block; text-align: left">{{ item.league }}</span>
                    </td>
                </template>
                <template #event="{item, index}">
                    <td>
                        <span style="display: block; text-align: left">H: {{ item.hName }}</span>
                        <span style="display: block; text-align: left">A: {{ item.aName }}</span>
                    </td>
                </template>
                <template #startingAt="{item, index}">
                    <td class="group-fixture-first">
                        {{item.startingAt_Str}}
                    </td>
                </template>
                <template #home_odds="{item, index}">
                    <td class="home_odds_cell">
                        {{item.home_odds}}
                    </td>
                </template>
                <template #draw_odds="{item, index}">
                    <td class="draw_odds_cell">
                        {{item.draw_odds}}
                    </td>
                </template>
                <template #away_odds="{item, index}">
                    <td class="away_odds_cell">
                        {{item.away_odds}}
                    </td>
                </template>
                <template #Fav_Label="{item, index}">
                    <td class="group-fav-label-first">
                        {{ item["Fav Label Display"] }}
                    </td>
                </template>
                <template #Bet="{item, index}">
                    <td class="bet_odds_cell">
                        {{ item.Bet }}
                    </td>
                </template>
                <template #ht_under_05_odds="{item, index}">
                    <td class="ht_under_05_odds_cell">
                        {{ item.ht_under_05_odds }}
                    </td>
                </template>
                <template #ht_over_05_odds="{item, index}">
                    <td class="ht_over_05_odds_cell">
                        {{ item.ht_over_05_odds }}
                    </td>
                </template>
                <template #under_25_odds="{item, index}">
                    <td class="under_25_odds_cell">
                        {{ item.under_25_odds }}
                    </td>
                </template>
                <template #over_25_odds="{item, index}">
                    <td class="over_25_odds_cell">
                        {{ item.over_25_odds }}
                    </td>
                </template>
                <template #bts_odds="{item, index}">
                    <td class="bts_odds_cell">
                        {{ item.bts_odds }}
                    </td>
                </template>
                <template #no_bts_odds="{item, index}">
                    <td class="no_bts_odds_cell">
                        {{ item.no_bts_odds }}
                    </td>
                </template>
            </CDataTable>
            <div style="justify-content: center;display: flex;background-color: rgb(83,83,83);">
                <div style="font-weight: bold; font-size: 12px; color: white; background-color: rgb(83,83,83); padding-bottom: 10px; padding-left: 10px;">
                    <div style="padding-top: 10px; padding-bottom: 15px;">
                        <label style="float:left; font-weight: bold; margin-right: 10px;">{{ $t('Last Updated') }}:</label>
                        <div style="float: left;">{{ last_updated_time }}</div>
                    </div>
                </div>
            </div>
        </CCardBody>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import { Plotly } from 'vue-plotly';
import swal from "sweetalert2";
import { convertUTCToLocal } from '../helpers/time';
import { mapState } from 'vuex';

export default {
    name: 'StatisticTable',
    components: {
        Plotly,
    },
    data() {
        return {
            last_updated_time: "",
            current_day: 0,
            week_filter: [
                { value: 0, label: this.$t('today') },
                { value: 1, label: this.$t('tomorrow') },
            ],
            startDate: 1325376000000,
            endDate: 1330560000000,
            items: [],
            fields: [
                { key: 'startingAt', label: this.$t('Time '), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-fixture' },
                { key: 'competition', label: this.$t('Competition '), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-fixture' },
                { key: 'event', label: this.$t('event'), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-fixture' },
                { key: 'Rnd', label: this.$t('Rnd'), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-fixture' },
                { key: 'Stats', label: this.$t('Stats'), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-stats' },
                { key: '0.5HT', label: this.$t('0.5HT'), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-stats' },
                { key: '1.5', label: this.$t('1.5'), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-stats' },
                { key: '2.5', label: this.$t('2.5'), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-stats' },
                { key: 'bts', label: this.$t('bts'), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-stats' },
                { key: '0-15', label: this.$t('0-15'), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-stats' },
                { key: '79-90', label: this.$t('79-90'), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-stats' },
                { key: 'Favorite', label: this.$t('Favorite'), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-fav-label' },
                { key: 'Pts', label: this.$t('Pts'), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-fav-label' },
                { key: 'Bet', label: this.$t('Bet'), _style: "padding-left: 5px; padding-right: 5px;", class: 'bet_odds_cell' },
                { key: 'match_odds_val', label: this.$t('Vol €'), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-match-odds' },
                { key: 'home_odds', label: this.$t('Home'), _style: "padding-left: 5px; padding-right: 5px;", class: 'home_odds_cell' },
                { key: 'draw_odds', label: this.$t('Draw'), _style: "padding-left: 5px; padding-right: 5px;", class: 'draw_odds_cell' },
                { key: 'away_odds', label: this.$t('Away'), _style: "padding-left: 5px; padding-right: 5px;", class: 'away_odds_cell' },
                { key: 'ou05_ht_odds_val', label: this.$t('Vol €'), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-ou05-ht' },
                { key: 'ht_under_05_odds', label: this.$t('U0.5'), _style: "padding-left: 5px; padding-right: 5px;", class: 'ht_under_05_odds_cell' },
                { key: 'ht_over_05_odds', label: this.$t('O0.5'), _style: "padding-left: 5px; padding-right: 5px;", class: 'ht_over_05_odds_cell' },
                { key: 'ou25_odds_val', label: this.$t('Vol €'), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-ou25-ft' },
                { key: 'under_25_odds', label: this.$t('U2.5'), _style: "padding-left: 5px; padding-right: 5px;", class: 'under_25_odds_cell' },
                { key: 'over_25_odds', label: this.$t('O2.5'), _style: "padding-left: 5px; padding-right: 5px;", class: 'over_25_odds_cell' },
                { key: 'bts_odds_val', label: this.$t('Vol €'), _style: "padding-left: 5px; padding-right: 5px;", class: 'group-bts' },
                { key: 'bts_odds', label: this.$t('BTS'), _style: "padding-left: 5px; padding-right: 5px;", class: 'bts_odds_cell' },
                { key: 'no_bts_odds', label: this.$t('No BTS'), _style: "padding-left: 5px; padding-right: 5px;", class: 'no_bts_odds_cell' },
            ],
            loading: true,
            _loading: true
        }
    },
    computed: {
        ...mapState({
            locale: state => state.locale
        })
    },
    mounted: function () {
        this.$nextTick(function () {
            this.set_items(0, false);

            setInterval(() => this.update_items(), 600 * 1000);

        })
    },
    methods: {
        ...mapActions([
            'getTeams5YearStats'
        ]),
        update_items() {
            if (this._loading == false) {
                this.set_items(this.current_day, true);
            }
        },
        set_items(val, updated_flag) {
            this.current_day = val;
            this._loading = true;

            if (updated_flag !== true) {
                this.items = [];
                this.showModal();
                this.loading = true;
            }
            this.getTeams5YearStats({ interval: val }).then((data) => {
                let events = [];

                if (data.fResults) {
                    let _home5yearsStats = data.home5yearsStats;
                    let _away5yearsStats = data.away5yearsStats;
                    let _league5yearsStats = data.league5yearsStats;
                    let _seasonRoundIds = data.seasonRoundIds;
                    let _livePageMarkets_pre = data.livePageMarkets_pre;

                    for (let event of data.fResults) {
                        let eItem = {
                            'startingAt': '',
                            'competition': '',
                            'country': '',
                            'league': '',
                            'event': '',
                            'homeId': '',
                            'awayId': '',
                            'Rnd': '',
                            'Stats': '',
                            '0.5HT': '',
                            '1.5': '',
                            '2.5': '',
                            'bts': '',
                            '0-15': '',
                            '79-90': '',
                            'Fav Label': '',
                            'Favorite': '', // Add this line
                            'Pts': '',
                            'Bet': '',
                            'match_odds_val': '',
                            'home_odds': '',
                            'draw_odds': '',
                            'away_odds': '',
                            "match_marketId": '',

                            'ou05_ht_odds_val': '',
                            'ht_under_05_odds': '',
                            'ht_over_05_odds': '',
                            "ou05_ht_marketId": '',

                            'ou25_odds_val': '',
                            'under_25_odds': '',
                            'over_25_odds': '',
                            "ou25_marketId": '',

                            'bts_odds_val': '',
                            'no_bts_odds': '',
                            'bts_odds': '',
                            "bts_marketId": '',
                        };

                        let _id = event._id;
                        let leagueId = event.leagueId;
                        let round_id = event.round_id;

                        let home5yearsStats = _home5yearsStats.filter(item => item.team_id == event.localTeamId && item.league_id == leagueId);
                        let away5yearsStats = _away5yearsStats.filter(item => item.team_id == event.visitorTeamId && item.league_id == leagueId);
                        let league5yearsStats = _league5yearsStats.filter(item => item.league_id == leagueId);
                        let seasonRoundIds = _seasonRoundIds.filter(item => item.round_id == round_id);
                        let livePageMarkets_pre = _livePageMarkets_pre.filter(item => item.fixtureId == _id);

                        let startingAt = convertUTCToLocal(event.time.starting_at.date_time);
                        eItem['startingAt'] = event.time.starting_at.date_time;
                        eItem['startingAt_Str_'] = startingAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
                        eItem['startingAt_Str'] = eItem['startingAt_Str_'].slice(0, -3);

                        let ap = eItem['startingAt_Str_'].slice(-2);
                        if (ap == "PM" && eItem['startingAt_Str'].slice(0, 2) != 12) {
                            let hour = 12 + parseInt(eItem['startingAt_Str'].slice(0, 2));
                            let minute = eItem['startingAt_Str'].slice(3, 5);
                            eItem['startingAt_Str'] = hour.toString() + ":" + minute;
                        }

                        if (league5yearsStats.length > 0) {
                            let country = league5yearsStats[0].country_name;
                            let league_name = league5yearsStats[0].league_name;
                            eItem["competition"] = country + "<br>" + league_name;
                            eItem["country"] = country;
                            eItem["league"] = league_name;
                        }
                        eItem["event"] = "H: " + event.localTeamName + "\n" + "A: " + event.visitorTeamName;
                        eItem["hName"] = event.localTeamName;
                        eItem["aName"] = event.visitorTeamName;
                        eItem["_id"] = _id;
                        eItem["Rnd"] = seasonRoundIds.length > 0 ? seasonRoundIds[0].name : "";


                        let homeEvents = [];
                        let awayEvents = [];
                        let homeStats;
                        let awayStats;
                        let leagueStats;

                        let home_last_10_stats;
                        let away_last_10_stats;

                        if (home5yearsStats.length > 0) {
                            homeStats = home5yearsStats[0].as_home;
                            home_last_10_stats = home5yearsStats[0].home_last_10_stats;
                        }
                        if (away5yearsStats.length > 0) {
                            awayStats = away5yearsStats[0].as_away;
                            away_last_10_stats = away5yearsStats[0].away_last_10_stats;
                        }
                        if (league5yearsStats.length > 0) {
                            leagueStats = league5yearsStats[0].as_league;
                        }

                        if (home_last_10_stats && away_last_10_stats) {
                            let events_count = home_last_10_stats.total_matches + away_last_10_stats.total_matches;
                            let count_05_ht = home_last_10_stats["0.5 HT"] + away_last_10_stats["0.5 HT"];
                            let count_15_ft = home_last_10_stats["1.5"] + away_last_10_stats["1.5"];
                            let count_25_ft = home_last_10_stats["2.5"] + away_last_10_stats["2.5"];
                            let count_bts = home_last_10_stats["bts"] + away_last_10_stats["bts"];
                            let count_0_to_15 = home_last_10_stats["0-15"] + away_last_10_stats["0-15"];
                            let count_79_to_90 = home_last_10_stats["79-90"] + away_last_10_stats["79-90"];

                            eItem["0.5HT"] = parseInt(count_05_ht / events_count * 100);
                            eItem["1.5"] = parseInt(count_15_ft / events_count * 100);
                            eItem["2.5"] = parseInt(count_25_ft / events_count * 100);
                            eItem["bts"] = parseInt(count_bts / events_count * 100);
                            eItem["0-15"] = parseInt(count_0_to_15 / events_count * 100);
                            eItem["79-90"] = parseInt(count_79_to_90 / events_count * 100);
                        }

                        for (let odd of livePageMarkets_pre) {
                            if (odd.marketType === "MATCH_ODDS") {
                                if (odd.runners) {
                                    if (odd.runners[0]) {
                                        let runnerNode = odd.runners[0];
                                        if (runnerNode.exchange) {
                                            if (runnerNode.exchange.availableToBack) {
                                                if (runnerNode.exchange.availableToBack[0]) {
                                                    eItem["home_odds"] = runnerNode.exchange.availableToBack[0].price;
                                                }
                                            }
                                        }
                                    }
                                    if (odd.runners[1]) {
                                        let runnerNode1 = odd.runners[2];
                                        if (runnerNode1.exchange) {
                                            if (runnerNode1.exchange.availableToBack) {
                                                if (runnerNode1.exchange.availableToBack[0]) {
                                                    eItem["draw_odds"] = runnerNode1.exchange.availableToBack[0].price;
                                                }
                                            }
                                        }
                                    }
                                    if (odd.runners[2]) {
                                        let runnerNode2 = odd.runners[1];
                                        if (runnerNode2.exchange) {
                                            if (runnerNode2.exchange.availableToBack) {
                                                if (runnerNode2.exchange.availableToBack[0]) {
                                                    eItem["away_odds"] = runnerNode2.exchange.availableToBack[0].price;
                                                }
                                            }
                                        }
                                    }
                                }
                                if (odd.totalMatched !== null && odd.totalMatched !== undefined) {
                                    eItem['match_odds_val'] = odd.totalMatched;
                                    eItem['match_marketId'] = odd.marketId;
                                }
                            }
                            else if (odd.marketType === "FIRST_HALF_GOALS_05" || odd.marketType === "OVER_UNDER_25" || odd.marketType === "BOTH_TEAMS_TO_SCORE") {
                                if (odd.runners && odd.runners.length > 0) {
                                    let runnerNode = odd.runners[0];
                                    if (runnerNode.exchange) {
                                        if (runnerNode.exchange.availableToBack) {
                                            if (runnerNode.exchange.availableToBack[0]) {
                                                if (odd.marketType === "FIRST_HALF_GOALS_05")
                                                    eItem["ht_under_05_odds"] = runnerNode.exchange.availableToBack[0].price;
                                                else if (odd.marketType === "OVER_UNDER_25")
                                                    eItem["under_25_odds"] = runnerNode.exchange.availableToBack[0].price;
                                                else if (odd.marketType === "BOTH_TEAMS_TO_SCORE") {
                                                    eItem["bts_odds"] = runnerNode.exchange.availableToBack[0].price;
                                                }
                                            }
                                        }
                                    }
                                }
                                if (odd.runners && odd.runners.length > 1) {
                                    let runnerNode1 = odd.runners[1];
                                    if (runnerNode1.exchange) {
                                        if (runnerNode1.exchange.availableToBack) {
                                            if (runnerNode1.exchange.availableToBack[0]) {
                                                if (odd.marketType === "FIRST_HALF_GOALS_05")
                                                    eItem["ht_over_05_odds"] = runnerNode1.exchange.availableToBack[0].price;
                                                else if (odd.marketType === "OVER_UNDER_25")
                                                    eItem["over_25_odds"] = runnerNode1.exchange.availableToBack[0].price;
                                                else if (odd.marketType === "BOTH_TEAMS_TO_SCORE") {
                                                    eItem["no_bts_odds"] = runnerNode1.exchange.availableToBack[0].price;
                                                }

                                            }
                                        }
                                    }
                                }

                                if (odd.totalMatched !== null && odd.totalMatched !== undefined) {
                                    if (odd.marketType === "FIRST_HALF_GOALS_05") {
                                        eItem['ou05_ht_odds_val'] = odd.totalMatched;
                                        eItem['ou05_ht_marketId'] = odd.marketId;
                                    }
                                    if (odd.marketType === "OVER_UNDER_25") {
                                        eItem['ou25_odds_val'] = odd.totalMatched;
                                        eItem['ou25_marketId'] = odd.marketId;
                                    }
                                    if (odd.marketType === "BOTH_TEAMS_TO_SCORE") {
                                        eItem['bts_odds_val'] = odd.totalMatched;
                                        eItem['bts_marketId'] = odd.marketId;
                                    }
                                }
                            }
                        }

                        let fav_odds;
                        if (eItem["home_odds"] && eItem["away_odds"]) {
                            if (eItem["home_odds"] <= 3 && eItem["away_odds"] <= 3) {
                                fav_odds = "SuperCompetative";
                            }
                            else if (eItem["home_odds"] <= 1.5) {
                                fav_odds = "H_StrongFav";
                            }
                            else if (eItem["home_odds"] > 1.5 && eItem["home_odds"] <= 2) {
                                fav_odds = "H_MediumFav";
                            }
                            else if (eItem["home_odds"] > 2 && eItem["home_odds"] <= 3) {
                                fav_odds = "H_SmallFav";
                            }

                            else if (eItem["away_odds"] <= 1.5) {
                                fav_odds = "A_StrongFav";
                            }
                            else if (eItem["away_odds"] > 1.5 && eItem["away_odds"] <= 2) {
                                fav_odds = "A_MediumFav";
                            }
                            else if (eItem["away_odds"] > 2 && eItem["away_odds"] <= 3) {
                                fav_odds = "A_SmallFav";
                            }
                        }

                        if (fav_odds) {
                            eItem["Fav Label"] = fav_odds; // Use original value for logic
                            // Add the translation logic here
                            const translations = {
                                "SuperCompetative": this.$t("Equilibrata"),
                                "A_MediumFav": this.$t("Ospite_med_fav"),
                                "A_SmallFav": this.$t("Ospite_min_fav"),
                                "H_MediumFav": this.$t("Casa_med_fav"),
                                "H_SmallFav": this.$t("Casa_min_fav"),
                                "A_StrongFav": this.$t("Ospite_max_fav"),
                                "H_StrongFav": this.$t("Casa_max_fav"),
                            };
                            eItem["Favorite"] = translations[fav_odds] || fav_odds;
                            if (homeStats && awayStats && leagueStats) {
                                let pts_val = {
                                    "home_back": 0,
                                    "home_lay": 0,
                                    "draw_back": 0,
                                    "draw_lay": 0,
                                    "away_back": 0,
                                    "away_lay": 0
                                }
                                let pts_dict = {
                                    "home_back": "BackHome",
                                    "home_lay": "LayHome",
                                    "draw_back": "BackDraw",
                                    "draw_lay": "LayDraw",
                                    "away_back": "BackAway",
                                    "away_lay": "LayAway"
                                }
                                let _labels = ["home_back", "home_lay", "draw_back", "draw_lay", "away_back", "away_lay"];
                                for (let _label of _labels) {
                                    pts_val[_label] += homeStats[fav_odds][_label].pts;
                                    pts_val[_label] += awayStats[fav_odds][_label].pts;
                                    pts_val[_label] += leagueStats[fav_odds][_label].pts;
                                }
                                let max_pts = 0;
                                let max_label;
                                for (let _label of _labels) {
                                    if (pts_val[_label] > max_pts) {
                                        max_pts = pts_val[_label];
                                        max_label = pts_dict[_label];
                                    }
                                }
                                if (max_label) {
                                    eItem["Pts"] = parseFloat(max_pts.toFixed(2));
                                    eItem["Bet"] = this.$t(max_label);
                                }
                            }
                        }

                        events.push(eItem);
                    }

                    var d = new Date();
                    var hour = d.getHours();
                    var minute = d.getMinutes();
                    var second = d.getSeconds();
                    if (hour < 10) {
                        hour = '0' + hour;
                    }
                    if (minute < 10) {
                        minute = '0' + minute;
                    }
                    if (second < 10) {
                        second = '0' + second;
                    }
                    this.last_updated_time = hour + ":" + minute + ":" + second;
                }
                this.items = events;
            }).finally(() => {
                if (updated_flag !== true)
                    this.hideModal();
                this.loading = false;
                this._loading = false;
            });
        },

        showModal() {
            this.$bvModal.show('modal-1');
        },
        hideModal() {
            this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow');
        },
    }
}
</script>

<style scoped>
.mfe-2 {
    display: none !important;
}

.table-responsive {
    max-height: 80vh !important;
    margin-top: 20px !important;
    border-radius: 15px;
}

thead {
    padding: 3px;
    position: sticky;
    top: 0;
    z-index: 1;
    background: #333;
    color: #fff;
    border-radius: 15px 15px 0 0;
}

.table_first_tr {
    background-color: #5a9;
    color: #fff;
    border-radius: 15px 15px 0 0;
}

.table_first_tr + tr {
    background-color: #7bb;
    color: #fff;
}

.team_stats_table th {
    padding: 10px;
    background-color: #444;
    color: #fff;
    border: 1px solid #555;
    border-radius: 10px;
}

.team_stats_table td {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 10px;
}

.home_odds_cell {
    background-color: #e8f5e9;
    color: #333;
    border-radius: 10px;
}

.draw_odds_cell {
    background-color: #e8f5e9;
    color: #333;
    border-radius: 10px;
}

.away_odds_cell {
    background-color: #e8f5e9;
    color: #333;
    border-radius: 10px;
}

.bet_odds_cell:not(:empty) {
    background-color: #F5F5F5;
    color: #333;
    border-radius: 10px;
}

.ht_under_05_odds_cell {
    background-color: #e8f5e9;
    color: #333;
    border-radius: 10px;
}

.ht_over_05_odds_cell {
    background-color: #e8f5e9;
    color: #333;
    border-radius: 10px;
}

.under_25_odds_cell {
    background-color: #e8f5e9;
    color: #333;
    border-radius: 10px;
}

.over_25_odds_cell {
    background-color: #e8f5e9;
    color: #333;
    border-radius: 10px;
}

.bts_odds_cell {
    background-color: #e8f5e9;
    color: #333;
    border-radius: 10px;
}

.no_bts_odds_cell {
    background-color: #e8f5e9;
    color: #333;
    border-radius: 10px;
}

.group-header {
    background-color: #5a9;
    color: #fff;
    padding: 5px;
    border-radius: 10px;
}

.group-fixture {
    background-color: #e8f5e9;
}

.group-stats {
    background-color: #ffebee;
    border-left: 3px solid #5a9;
}

.group-fav-label {
    background-color: #e3f2fd;
    border-left: 3px solid #5a9;
}

.group-match-odds {
    background-color: #f9fbe7;
    border-left: 3px solid #5a9;
}

.group-ou05-ht {
    background-color: #ffecb3;
    border-left: 3px solid #5a9;
}

.group-ou25-ft {
    background-color: #d1c4e9;
    border-left: 3px solid #5a9;
}

.group-bts {
    background-color: #ffcdd2;
    border-left: 3px solid #5a9;
}

.group-fixture-first {
    background-color: #c8e6c9;
}

.group-stats-first {
    background-color: #ffcdd2;
}

.group-fav-label-first {
    background-color: #c8e6c9;
}

.group-match-odds-first {
    background-color: #c8e6c9;
}

.group-ou05-ht-first {
    background-color: #c8e6c9;
}

.group-ou25-ft-first {
    background-color: #c8e6c9;
}

.group-bts-first {
    background-color: #c8e6c9;
}

.team_stats_table tr:hover {
    background-color: #f5f5f5 !important;
    transition: background-color 0.3s ease;
}

.team_stats_table tr:hover .group-fixture-first {
    background-color: #c8e6c9 !important;
}

.team_stats_table tr:hover .group-stats-first {
    background-color: #FD9EFF !important;
}

.team_stats_table tr:hover .group-fav-label-first {
    background-color: #c8e6c9 !important;
}

.team_stats_table tr:hover .group-match-odds-first {
    background-color: #c8e6c9 !important;
}

.team_stats_table tr:hover .group-ou05-ht-first {
    background-color: #c8e6c9 !important;
}

.team_stats_table tr:hover .group-ou25-ft-first {
    background-color: #c8e6c9 !important;
}

.team_stats_table tr:hover .group-bts-first {
    background-color: #c8e6c9 !important;
}

.team_stats_table tr:hover .home_odds_cell {
    background-color: #d0f0c0 !important;
}

.team_stats_table tr:hover .draw_odds_cell {
    background-color: #d0f0c0 !important;
}

.team_stats_table tr:hover .away_odds_cell {
    background-color: #d0f0c0 !important;
}

.team_stats_table tr:hover .bet_odds_cell:not(:empty) {
    background-color: #33F92F !important;
}

.team_stats_table tr:hover .ht_under_05_odds_cell {
    background-color: #d0f0c0 !important;
}

.team_stats_table tr:hover .ht_over_05_odds_cell {
    background-color: #d0f0c0 !important;
}

.team_stats_table tr:hover .under_25_odds_cell {
    background-color: #d0f0c0 !important;
}

.team_stats_table tr:hover .over_25_odds_cell {
    background-color: #d0f0c0 !important;
}

.team_stats_table tr:hover .bts_odds_cell {
    background-color: #d0f0c0 !important;
}

.team_stats_table tr:hover .no_bts_odds_cell {
    background-color: #d0f0c0 !important;
}
</style>



